import { render, staticRenderFns } from "./Formazione_Tab5.vue?vue&type=template&id=b09ae41e&scoped=true&"
import script from "./Formazione_Tab5.vue?vue&type=script&lang=js&"
export * from "./Formazione_Tab5.vue?vue&type=script&lang=js&"
import style0 from "./Formazione_Tab5.vue?vue&type=style&index=0&id=b09ae41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09ae41e",
  null
  
)

export default component.exports